














import Vue from "vue";

import store from "@/store";

export default Vue.extend({
  name: "DataStructure",
  computed: {
    dataStructure() {
      const dataStructureName = this.$route.params.name;

      const dataStructures = store.getters.dataStructures;

      return dataStructures.find(
        (dataStructure) => dataStructure.resource === dataStructureName
      );
    },
  },
});
